import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { NotesEffects } from './notes.effects';
import { notesReducer } from './notes.reducer';

export const provideNotesStore = () => [provideState('notes', notesReducer), provideEffects([NotesEffects])];
